import { ISkuService } from './contracts/sku.service';

import apiClient from '../../api/index';
import { createUrl } from '_clean-code/utils/urlHelper';

export const SkuService: ISkuService = {
  getPaginatedSkus: async (params) =>
    apiClient.request('POST', createUrl('/skus/filters').toStringUrl(), params)
};
